import React, { useRef, useEffect } from 'react';
import { TouchableOpacity, PixelRatio, Animated, Modal, StyleSheet, View, Text, TextInput, KeyboardAvoidingView } from 'react-native';
import { useDimensions } from 'react-native-web-hooks';
import useFontSize from '../shell/hooks/useFontSize';
import { isMobile } from '../shell/utils/platformCheck';

export interface PromptQuestionModalProps {
    onSubmit: (input: string | boolean) => void,
    placeHolder?: string,
    defaultValue?: string,
    title?: string,
    showCancel?: boolean;
    hideInputField?: boolean;

}
export const PromptQuestionModal: React.FC<PromptQuestionModalProps> = ({ onSubmit, placeHolder, defaultValue, title, showCancel, hideInputField }) => {
    const [value, setValue] = React.useState('');
    const inputTextRef = useRef<TextInput | null>();
    let { width, height } = useDimensions().window;
    useEffect(() => {
        if (defaultValue) {
            setValue(defaultValue);
        }

    }, [defaultValue]);
    const styles = StyleSheet.create({

        modalOverlay: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            height: height,
            backgroundColor: 'rgba(0,0,0,0.85)',
        }, text: {
            alignSelf: "center",
            justifyContent: "center",
            textAlign: "center",
            margin: 20,
            paddingTop: 20,
            paddingBottom: 20,
            fontSize: useFontSize(2),
            borderBottomColor: "white",
            borderTopColor: "white",
            borderTopWidth: 2,
            borderBottomWidth: 2,
            color: "white"
        }
    });
    const onInputKeyPressed = (key: any) => {

    };
    const onSubmitClick = (cancel?: boolean) => {
        if (cancel !== undefined) { return onSubmit(false); }
        if (hideInputField) {
            return onSubmit(true);
        }
        if (value.trim()) {
            // onSubmit(defaultValue === value ? true : value);

            onSubmit(value);
        }

    };
    return (
        <Modal
            animationType={isMobile() ? "slide" : "fade"}
            statusBarTranslucent
            transparent={true}
            visible={true}
        >
            {/* <InstaNavBar onCloseClick={onCloseClickInsideModal} style={styles.navInsideModal} ></InstaNavBar> */}
            <KeyboardAvoidingView behavior="height"
                style={{
                    position: "absolute",
                    width,
                    height: "100%",
                    // backgroundColor: "red",
                    display: "flex",
                    justifyContent: "center",
                    alignSelf: "center"
                }}>
                <View style={styles.modalOverlay} />
                <View style={{
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <Text style={{
                        fontSize: useFontSize(2),
                        color: "white",
                        marginBottom: hideInputField ? "5%" : 0

                    }}>{title || placeHolder}</Text>

                    {hideInputField ? <></> : <TextInput
                        ref={(ref) => { inputTextRef.current = ref; }}
                        focusable
                        autoFocus
                        onChangeText={text => setValue(text)}
                        onSubmitEditing={(key) => { onSubmitClick(); }}
                        onKeyPress={(key) => onInputKeyPressed(key)}
                        placeholder={placeHolder}
                        keyboardAppearance={"dark"}
                        disableFullscreenUI
                        value={value}
                        selectTextOnFocus
                        editable

                        maxLength={100}
                        style={styles.text}>
                    </TextInput>}
                    <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>

                        <TouchableOpacity
                            onPress={() => onSubmitClick()}
                            style={{
                                borderColor: "white",
                                borderWidth: 2,
                                padding: 8,
                                paddingLeft: 15,
                                paddingRight: 15,
                                borderRadius: 10,

                            }}>
                            <Text style={{
                                color: "white",
                                fontSize: useFontSize(2),
                            }}>Submit</Text>
                        </TouchableOpacity>
                        {showCancel ? <TouchableOpacity
                            onPress={() => onSubmitClick(false)}
                            style={{
                                borderColor: "white",
                                borderWidth: 2,
                                marginLeft: 10,
                                padding: 8,
                                paddingLeft: 15,
                                paddingRight: 15,
                                borderRadius: 10,
                            }}>
                            <Text style={{
                                color: "white",
                                fontSize: useFontSize(2),
                            }}>Cancel</Text>
                        </TouchableOpacity> : <></>}
                    </View>
                </View>
            </KeyboardAvoidingView>
        </Modal>
    );
};